import { styled, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import DynamicTable from "components/ui/TableComponents/DynamicTable";
import React, { useEffect, useRef } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useExpiredCatalogSessions } from "./api/catalogPageApi";

const headers = [{ label: "Session Date & Time" }, { label: "Session Duration" }, { label: "Expire Date & Time" }, { label: "Status" }];
// const rowsData = [
//   ["08 Aug 2024 - 03:12:56 PM", "56:00:00", "09 Aug 2024 - 05:38:56 PM", "Inactive"],
//   ["03 Aug 2024 - 04:01:48 PM", "42:00:00", "04 Aug 2024 - 05:38:56 PM", "Inactive"],
//   ["27 July 2024 - 01:10:06 PM", "30:00:00", "28 July 2024 - 03:10:06 PM", "Inactive"],
// ];

const rowColors = [];

// utils/sessionFormatters.js

export const formatDateTime = (isoString) => {
  if (!isoString) return "-";

  const date = new Date(isoString);

  const day = date.getDate();
  const month = date.toLocaleString("en-GB", { month: "short" });
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12 || 12;

  return `${String(day).padStart(2, "0")} ${month} ${year} - ${String(hours).padStart(2, "0")}:${minutes}:${seconds} ${ampm}`;
};

export const formatDuration = (seconds = 0) => {
  const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
  const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
  const secs = String(seconds % 60).padStart(2, "0");

  return `${hrs}:${mins}:${secs}`;
};

export const mapExpiredSessionsToRows = (expiredSessions = []) => {
  return expiredSessions.map((session) => [
    formatDateTime(session.sessionCreatedDateTime),
    formatDuration(session.sessionDuration),
    formatDateTime(session.sessionExpireDateTime),
    session.status === "Expired" ? "Inactive" : session.status,
  ]);
};

function CatalogSessionScreen() {
  let location = useLocation();
  const { clientId } = useParams();

  const catalogId = location?.state?.catalogId;

  const {
    data: sessions = [],
    isLoading,
    isFetching,
    isError,
  } = useExpiredCatalogSessions({
    clientCode: clientId,
    catalogId,
  });

  let rowsData = React.useMemo(() => mapExpiredSessionsToRows(sessions), [sessions]);

  const sections = [
    {
      headers,
      rows: rowsData?.map((row, rowIndex) =>
        row.map((cell, cellIndex) => {
          const isStatus = cellIndex === row.length - 1;
          const statusColor = isStatus && cell?.toLowerCase() === "active" ? "#50C878" : isStatus ? "#E77B7B" : "#fff";

          return (
            <div
              key={`${rowIndex}-${cellIndex}`}
              style={{
                backgroundColor: Array.isArray(rowColors) && rowColors.length > 0 ? rowColors[rowIndex % rowColors.length] : "transparent",
                color: statusColor,
                fontWeight: 400,
                fontFamily: "Karla",
                fontSize: "16px",
                width: "100%",
                height: "100%",
                padding: "8px 0",
                cursor: "pointer",
              }}
            >
              {cell}
            </div>
          );
        })
      ),
    },
  ];

  // if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Something went wrong</div>;
  return <DynamicTable sections={sections} loading={false} error={false} maxHeight={"78.5vh"} isFetchingNextPage={isFetching} />;
}

export default CatalogSessionScreen;
